import React, { useEffect, useRef, useState } from "react";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Select, FormControl, FormGroup, FormControlLabel, Switch, InputLabel } from "@material-ui/core";
import { getKey } from "../../helpers/UrlHelper";
import PlauditTrack from "../../digitalArena/modules/Plaudit/PlauditTrack";
import { clientTypeConstants } from "../../interaction/constants/clientType.constants";
import { meetingService } from "../../services/meeting/meeting.service";
import SettingsIcon from "@material-ui/icons/Settings";
export default function PlauditPresenter(props) {
    const [showSettings, setShowSettings] = useState(true);
    const [eventCode, setEventCode] = useState(null);
    const [backgroundColor, setBackgroundColor] = useState("#00ff00");
    const [eventId, setEventId] = useState(null);
    const [channel, setChannel] = useState(null);
    const [eventName, setEventName] = useState(null);
    const [parentEventId, setParentEventId] = useState(null);
    const [name, setName] = useState(null);
    const [hubConnection, setHubConnection] = useState(null);
    const [connecting, setConnecting] = useState(false);
    const [connected, setConnected] = useState(false);
    const [countdown, setCountdown] = useState(null)
    const [reconnectCounter, setReconnectCounter] = useState(null);
    const onConnectionCloseRef = useRef();
    useEffect(() => {
        const { location, match } = props;
        let eventCode = match.params.id;
        const params = new URLSearchParams(location.search);
        setEventCode(eventCode);
        const channel = params.get(getKey("channel", params));
        if (channel) {
            setChannel(channel)
        }
        meetingService.getEventId(eventCode).then(({ eventId, eventName, parentEventId }) => {
            setEventId(eventId);
            setEventName(eventName);
            setParentEventId(parentEventId);
            // axios.get(`./api/template/event/${eventId}?includeInherited=true`).then(({ data }) => {
            //     setTemplateList(data);
            // })
        });
    }, []);
    useEffect(() => {
        onConnectionCloseRef.current = onConnectionClose;
        if (hubConnection) {
            hubConnection.on("onHandshake", onHandshake);
        }

        return () => {
            if (hubConnection) {
                hubConnection.off("onHandshake", onHandshake);
            }
        }
    });
    const onHandshake = (response) => {
        const { success } = response;
        if (!success) {
            setConnected(false);
            return;
        }
        setConnecting(false);
        setConnected(true);
    }
    useEffect(() => {
        if (connected == false && connecting == false && hubConnection?.connectionState === 0) {
            tryReconnect();
            var counter = setInterval(() => {
                setCountdown((prevCount) => prevCount + 1);
            }, 1000);
            if (reconnectCounter) clearInterval(reconnectCounter);
            setReconnectCounter(counter);
        } else if (countdown >= 60 && !connected && hubConnection) {
            setCountdown(0);
            setConnecting(false);
            tryReconnect();
        } else if (connected == true && !connecting && hubConnection && hubConnection.connectionState == 1) {
            if (reconnectCounter) clearInterval(reconnectCounter);
            setCountdown(0);
            setReconnectCounter(null);
        }
    }, [connected, connecting, countdown]);
    function tryReconnect() {
        if (!connecting && !connected && hubConnection) {
            connectToHub();
        }
    }
    const connectToHub = () => {
        let hc = hubConnection;
        if (!hc) hc = new HubConnectionBuilder().withUrl("./ihub").build();
        setConnecting(true);
        hc
            .start()
            .then(() => {
                hc.onclose(() => onConnectionCloseRef.current());
                const handshakeObj = {
                    eventId: eventId,
                    clientType: clientTypeConstants.INTERACTION_PLAUDIT_PRESENTER,
                    clientKey: null,
                    channel: channel ? channel : null,
                    exhibitorId: null,
                    code: null,
                    userGuid: null,
                    userInfo: null,
                };
                hc.invoke("handshake", handshakeObj);
            })
            .catch(function (e) {
                console.error(e);
            });
        setHubConnection(hc);
    };
    const onConnectionClose = () => {
        setConnected(false);
    }
    function saveSettings() {
        if (!hubConnection) {
          connectToHub();
        }
        // else {
        //   hubConnection.invoke("UpdateVideoWallSettings", eventId, name, session.id, screenNo, maxVids);
        // }
        setShowSettings(false)
      }
    return <div style={{ width: "100vw", height: "100vh" }}>
        <IconButton id="hidden-settings-btn" onClick={() => setShowSettings(true)} style={{ position: "absolute", top: "1%", right: "1%" }}>
            <SettingsIcon />
        </IconButton>
        <Dialog open={showSettings} onClose={() => saveSettings()} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Inställningar - {eventName}</DialogTitle>
            <DialogContent>
                <TextField
                    variant="outlined"
                    margin="dense"
                    id="backgroundColor"
                    label="Bakgrundsfärg"
                    type="text"
                    fullWidth
                    value={backgroundColor}
                    onChange={(e) => {
                        setBackgroundColor(e.target.value || '');
                    }}
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={saveSettings} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
        {hubConnection && hubConnection.connectionState == 1 ?
            <PlauditTrack {...{ eventId, settings: { backgroundColor }, hubConnection }} />
            : null}
    </div>
}